<h1 mat-dialog-title>Anexos Veículo</h1>

<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step>
    <ng-template matStepLabel>Anexos</ng-template>
    <app-anexos
      #anexos
      [options]="{
        hideUpload: true,
        disableDelete: true
      }"
    >
    </app-anexos>
  </mat-step>
</mat-horizontal-stepper>

<div mat-dialog-actions align="end">
  <button type="submit" mat-flat-button [disabled]="!anexos.files" (click)="onClose()">
    Fechar
  </button>
</div>
